import React from 'react';
import { View } from 'react-native';
import CornerTopRightSvg from '@assets/images/svg/doc-capture/corner-top-right.svg';

export interface CornerTopRightIconProps {
    size?: number;
}

export function CornerTopRightIcon({ size = 71 }: CornerTopRightIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CornerTopRightSvg width={size} height={size} />
        </View>
    );
}

export default CornerTopRightIcon;

